import React, { useEffect, useState } from "react"
import ArrowRight from "../../components/icons/ArrowRight"
import LazyImage from "../../components/LazyImage"

import "./index.scss"
import BigNumList from "../../features/big-num-list"
import { IT_CONSULTING_AND_ADVISORY_SERVICES } from "../../data/consulting-and-advisory/services"
import { OurClients } from "../../features/our-clients"
import { Gallery } from "../../features/gallery"
import { WHY_CONSULTING_WITH_US } from "../../data/consulting-and-advisory/services"
import { useMediaQuery } from "react-responsive"
import { DESKTOP_WIDTH } from "../../constants/common"
import { OUR_EXPERTS } from "../../data/about-us/people"
import { PeopleCard } from "../../features/people-card"
import PlusIcon from "../../components/icons/PlusIcon"
import MinusIcon from "../../components/icons/MinusIcon"
import { GetInTouch } from "../../utils"
import { Helmet } from "react-helmet-async"

const ITConsultingAndAdvisory = () => {
    const isDesktop = useMediaQuery({ minWidth: DESKTOP_WIDTH })
    const [showMore, setShowMore] = useState(false)
    const [visibleItems, setVisibleItems] = useState(3)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft - IT Consulting & Advisory Services</title>
            </Helmet>
            <div className="itconsulting">
                <div className="itconsulting-header">
                    <h3 className="t-h1-m">IT Consulting & Advisory Services </h3>
                    <p className="t-b4">
                    Our senior engineering experts assess your current business state and build a technology strategy to help improve the performance, scalability and competitiveness of your company.
                    </p>
                    <a
                        onClick={() => {
                            GetInTouch()
                        }}
                        className="itconsulting-header-link t-nav hov-get-in-touch-black"
                    >
                        {" "}
                        get in touch
                        <ArrowRight width={26} color={"white"} />
                    </a>
                </div>
                <div className="itconsulting-image">
                    <LazyImage
                        src={
                            "https://newsoft-ns.com/media/consulting_and_advisory/it_consulting.webp"
                        }
                        alt="Newsoft people"
                    />
                </div>
                <BigNumList
                    header="Our IT Consulting & Advisory Services"
                    list={IT_CONSULTING_AND_ADVISORY_SERVICES}
                    className="big-num-list-dark"
                />
                <div className="itconsulting-with-us">
                    <h1 className="t-h1">Why Consulting with us</h1>
                    {!isDesktop && (
                        <div className="itconsulting-with-us-image">
                            <LazyImage
                                src="https://newsoft-ns.com/media/consulting_and_advisory/it_consulting1_mobile.webp"
                                alt="Newsoft people"
                            ></LazyImage>
                        </div>
                    )}
                    <div className="itconsulting-with-us-items">
                        {WHY_CONSULTING_WITH_US.map((el, id) => (
                            <div
                                key={id}
                                className="itconsulting-with-us-items-item"
                            >
                                <div className="itconsulting-with-us-items-item-image">
                                    <LazyImage src={el.image} alt="newsoft consulting"/>
                                </div>
                                <div>
                                    <h2 className="t-s1">{el.header}</h2>
                                    <hr />
                                    <p className="itconsulting-with-us-items-item-text t-b4">
                                        {el.text}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="itconsulting-experts">
                    <div className="itconsulting-experts-people">
                        <div className="itconsulting-experts-people-block">
                            <h3 className="t-s3">Our experts</h3>
                            {isDesktop ?
                                <div className="itconsulting-experts-people-list">
                                    {OUR_EXPERTS.map((person) => (
                                        <PeopleCard key={person.image} {...person} />
                                    ))}
                                </div> :
                                <div className="itconsulting-experts-people-list">
                                    {OUR_EXPERTS.slice(0, visibleItems).map((person, id) => (
                                        <>
                                            <PeopleCard key={id} {...person} />
                                    
                                            {id >= visibleItems-1 && !showMore && (
                                                <h6 className="itconsulting-nav t-nav" onClick={() => {setShowMore(true); setVisibleItems(OUR_EXPERTS.length)}}>
              LEARN MORE <PlusIcon color="black" />
                                                </h6>)}
                                            { id=== OUR_EXPERTS.length-1 && showMore && (
                                                <h6 className="itconsulting-nav t-nav" onClick={() => {setShowMore(false); setVisibleItems(3)}}>
              COLLAPSE <MinusIcon color="black" />
                                                </h6>
                                            )}
                                        </>
                                         
                                    ))}
                                </div> }
                        </div>
                    </div>
                </div>
            </div>
            <OurClients />
            <Gallery />
        </>
    )
}

export default ITConsultingAndAdvisory
